module.exports = __webpack_public_path__ + "static/media/up-arrow.d3aa372f.svg";